export const datatable = {
  headerCell: {
    color: '{colors.black}',
    selectedColor: '{colors.black}',
    hoverColor: '{colors.main}',
  },
  sortIcon: {
    color: '{colors.black}',
    hoverColor: '{colors.main}',
  },
};
